import { MonitoringAssortment } from '@retail/monitoring-assortment/types';
import React from 'react';
import { useOutletContext } from 'react-router';

export interface MonitoringAssortmentsProps {
  monitoringAssortments: MonitoringAssortment[];
  selectedAssortment?: MonitoringAssortment;
}

export const withMonitoringAssortments =
  (
    WrappedComponent: React.ComponentType<MonitoringAssortmentsProps>
  ): React.FC<Omit<MonitoringAssortmentsProps, 'monitoringAssortments' | 'selectedAssortment'>> =>
  (props) => {
    const { monitoringAssortments, selectedAssortment } = useOutletContext<{
      monitoringAssortments: MonitoringAssortment[];
      selectedAssortment?: MonitoringAssortment;
    }>();

    // @ts-ignore
    return (
      <WrappedComponent
        monitoringAssortments={monitoringAssortments}
        selectedAssortment={selectedAssortment}
        {...props}
      />
    );
  };
